module.exports = __webpack_public_path__ + "img/sample-logo2.f6c14bcc.png";